export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  UsePartialLineItemUrlInCart: 'specs.ecom.UsePartialLineItemUrlInCart',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  UpdateCartIconsSVGViewer: 'specs.ecom.UpdateCartIconsSVGViewer',
  DontHandleCheckoutNotAllowedInCart: 'specs.ecom.DontHandleCheckoutNotAllowedInCart',
  CartItemQuantityBadge: 'specs.ecom.CartItemQuantityBadge',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  ShowAdditionalFeesInSideCart: 'specs.ecom.ShowAdditionalFeesInSideCart',
  ResponsiveCart: 'specs.ecom.ResponsiveCart',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  FixCheckoutButtonAriaLabel: 'specs.ecom.FixCheckoutButtonAriaLabel',
  RemovePmNameErrorModal: 'specs.ecom.RemovePmNameErrorModal',
  HideSubscriptionBillingPeriodWhenProductPeriodNotAligned:
    'specs.ecom.HideSubscriptionBillingPeriodWhenProductPeriodNotAligned',
  ecomCartValidationsInPurchaseFlow: 'ecomCartValidationsInPurchaseFlow',
  ecomInlineAddressSelectionInCart: 'ecomInlineAddressSelectionInCart',
  SendRemoveLineItemAnalyticsFromCart: 'specs.ecom.SendRemoveLineItemAnalyticsFromCart',
  SuccessPopupUIchanges: 'specs.ecom.SuccessPopupUIchanges',
  ecomUseCartEstimationIndicators: 'ecomUseCartEstimationIndicators',
} as const;
